<template>
  <div class="flex items-center justify-center">
    <div v-for="(index) in count" :key="index" class="dotDivider"></div>
  </div>
</template>

<script>
export default {
  name: "DotsDivider.vue",
  props: {
    count: {
      type: Number,
      default: 3
    }
  }
}
</script>